import React, { useState, useMemo } from "react";
import { Table, Input, Button, Popconfirm, Tooltip, Space } from "antd";
import {
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import updateData from "../../../hooks/admin/updateData";
import deleteItem from "../../../hooks/admin/deleteItem";
import { toast } from "react-toastify";

const { Search } = Input;

export default function CustomerTable({ customerData, isSuspended }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState(customerData);
  const [filterText, setFilterText] = useState("");

  const filteredItems = useMemo(() => {
    return selectedData?.filter((item) =>
      item.cust_fullname.toLowerCase().includes(filterText.toLowerCase())
    );
  }, [selectedData, filterText]);

  const changeCustStatus = async (id, status) => {
    setLoading(true);
    const statusValue = status ? 0 : 1;
    const res = await updateData("admin/updatecustomer", {
      cust_id: id,
      status: statusValue,
    });

    if (res.status_code === 200) {
      toast.success(res.message);
      if (isSuspended) {
        const updated = selectedData.filter((c) => c.cust_id !== id);
        setSelectedData(updated);
      } else {
        const updated = selectedData.map((v) =>
          v.cust_id === id ? { ...v, status: statusValue } : v
        );
        setSelectedData(updated);
      }
    }

    setLoading(false);
  };

  const columns = [
    {
      title: t("Name"),
      dataIndex: "cust_fullname",
      key: "name",
      sorter: (a, b) => a.cust_fullname.localeCompare(b.cust_fullname),
    },
    {
      title: t("Email"),
      dataIndex: "cust_email",
      key: "email",
    },
    {
      title: t("Phone number"),
      dataIndex: "cust_phone",
      key: "phone",
    },
    {
      title: t("Domain"),
      dataIndex: "joined_at",
      key: "domain",
    },
    {
      title: t("Action"),
      key: "action",
      render: (_, record) => (
        <Space>
          <Tooltip title={t("Edit")}>
            <Link
              to={`/admin/customer/edit/${record.cust_id}`}
              className="text-success"
            >
              <Button
                type="default"
                icon={<EditOutlined />}
                size="small"
              />
            </Link>
          </Tooltip>

          <Tooltip title={t("Delete")}>
            <span
              onClick={() =>
                deleteItem(
                  record.cust_id,
                  selectedData,
                  setSelectedData,
                  filteredItems,
                  "cust_id",
                  "admin/deletecustomer"
                )
              }
            >
              <Button size="small" danger icon={<DeleteOutlined />} />
            </span>
          </Tooltip>

          {record.status === 0 ? (
            <Tooltip title={t("unsuspend")}>
              <Button
                type="default"
                icon={<CheckCircleOutlined />}
                size="small"
                onClick={() => changeCustStatus(record.cust_id, record.status)}
              />
            </Tooltip>
          ) : (
            <Tooltip title={t("Suspend")}>
              <Button
                type="default"
                icon={<MinusCircleOutlined />}
                danger
                size="small"
                onClick={() => changeCustStatus(record.cust_id, record.status)}
              />
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div className="dashboard-box">
      <div className="flex justify-end p-4">
        <Search
          placeholder={t("Filter by name")}
          allowClear
          onSearch={(value) => setFilterText(value)}
          onChange={(e) => setFilterText(e.target.value)}
          value={filterText}
          style={{ width: 300 }}
        />
      </div>

      <Table
        columns={columns}
        dataSource={filteredItems}
        rowKey="cust_id"
        loading={loading}
        pagination={{ pageSize: 10 }}
        bordered
      />
    </div>
  );
}

